'use client'

import { useAtom, useAtomValue } from 'jotai'
import Cookies from 'js-cookie'
import { useEffect } from 'react'

import { identify } from '@/lib/analytics'
import { flushAuthAnalyticsEvent, parseAuthAnalyticsCookie } from '@/lib/auth-analytics'
import { AUTH_ANALYTICS_COOKIE } from '@/lib/configs/auth-config'
import { authAtom } from '@/state/auth'
import { authAnalyticsEventAtom } from '@/state/auth-analytics'

/**
 * - identify(): whenever a userId is present (login, Google, restored session),
 *   so backend and frontend events join on the same distinct_id. Never tracks.
 * - Log in / Sign up: consumes the one-shot signal exactly once (clear first).
 *   The Google redirect callback can't write the atom (302, no client JS), so
 *   its cookie is converted to the same signal here on mount.
 */
export function AnalyticsSync() {
  const userId = useAtomValue(authAtom).user?.userId
  const [event, setEvent] = useAtom(authAnalyticsEventAtom)

  useEffect(() => {
    if (userId) void identify(userId)
  }, [userId])

  useEffect(() => {
    const fromCookie = parseAuthAnalyticsCookie(Cookies.get(AUTH_ANALYTICS_COOKIE))
    Cookies.remove(AUTH_ANALYTICS_COOKIE, { path: '/' })
    if (fromCookie) setEvent(fromCookie)
  }, [setEvent])

  useEffect(() => {
    if (!event) return
    setEvent(null)
    void flushAuthAnalyticsEvent(event)
  }, [event, setEvent])

  return null
}
